import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/materiales/searchMateriales.php';

export default function searchMateriales({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}